(function () {
  'use strict';
  if (window.HNAluminumCart) return;
  var lastCart = null;
  var queue = Promise.resolve();
  var syncTimer = null;
  var decorateTimer = null;
  var checkoutBusy = false;
  var snapshotDirty = true;
  var bypassTarget = null;
  var bypassForm = null;
  var checkoutSelector = 'button[name="checkout"],input[name="checkout"],[data-agree-btn],.hulkapps_checkout,a[href="/checkout"],a[href^="/checkout?"],a[href$="/checkout"]';
  var cartActionSelector = '[data-cart-remove],[data-action-change],[data-quantity-selector],.edit_cart_option,[data-action-quickshop]';
  function properties(item) { return item.properties || {}; }
  function token(item) { return String(properties(item)._hn_aluminum_config || ''); }
  function isFee(item) { return String(properties(item)._hn_aluminum_fee || '').toLowerCase() === 'true'; }
  function isParent(item) { return !isFee(item) && token(item) && Object.prototype.hasOwnProperty.call(properties(item), '_hn_aluminum_charges'); }
  function safeInteger(value, minimum) { return Number.isSafeInteger(Number(value)) && Number(value) >= minimum; }
  function rootUrl() {
    var path = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    return path.charAt(0) === '/' && path.indexOf('//') !== 0 ? path.replace(/\/?$/, '/') : '/';
  }
  async function request(path, body) {
    var options = {credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json'}};
    if (body) { options.method = 'POST'; options.headers['Content-Type'] = 'application/json'; options.body = JSON.stringify(body); }
    var response = await fetch(rootUrl() + path, options);
    var result;
    try { result = await response.json(); } catch (_) { throw new Error('The cart could not be checked. Please try again.'); }
    if (!response.ok || result.status >= 400) throw new Error('The selected door options could not be updated. Please try again.');
    return result;
  }
  async function readCart() {
    var cart = await request('cart.js');
    if (!cart || !Array.isArray(cart.items)) throw new Error('The cart could not be checked. Please try again.');
    lastCart = cart;
    snapshotDirty = false;
    decorateFeeRows();
    return cart;
  }
  function chargesFor(parent) {
    var value = properties(parent)._hn_aluminum_charges;
    var charges;
    try { charges = typeof value === 'string' ? JSON.parse(value) : value; } catch (_) {}
    if (!Array.isArray(charges) || charges.length > 30) throw new Error('The door options need to be selected again before checkout.');
    var grouped = Object.create(null);
    charges.forEach(function (charge) {
      if (!charge || !safeInteger(charge.variantId, 1) || !safeInteger(charge.quantityPerDoor, 1) || !safeInteger(charge.priceCents, 1) || !String(charge.name || '').trim()) throw new Error('The door options need to be selected again before checkout.');
      var entry = {variantId:Number(charge.variantId), quantityPerDoor:Number(charge.quantityPerDoor), priceCents:Number(charge.priceCents), name:String(charge.name).trim()};
      var id = entry.variantId + '|' + entry.name;
      if (grouped[id] && grouped[id].priceCents !== entry.priceCents) throw new Error('The door option prices could not be verified. Please reselect the options.');
      if (grouped[id]) grouped[id].quantityPerDoor += entry.quantityPerDoor;
      else grouped[id] = entry;
    });
    return Object.keys(grouped).map(function (key) { return grouped[key]; });
  }
  function feeName(item) { return String(properties(item)._hn_aluminum_fee_name || properties(item).Option || '').trim(); }
  function analyze(cart) {
    var parents = cart.items.filter(isParent);
    var parentByKey = Object.create(null);
    var records = parents.map(function (parent) {
      if (!parent.key || !safeInteger(parent.quantity, 1)) throw new Error('The door quantity could not be verified.');
      var record = {parent:parent, charges:chargesFor(parent), found:Object.create(null)};
      parentByKey[parent.key] = record;
      return record;
    });
    var updates = Object.create(null);
    cart.items.filter(isFee).forEach(function (item) {
      var relationship = item.parent_relationship;
      var record = relationship && parentByKey[relationship.parent_key];
      if (!record || token(item) !== token(record.parent)) { updates[item.key] = 0; return; }
      var candidates = record.charges.filter(function (charge) { return charge.variantId === Number(item.variant_id || item.id); });
      var match = candidates.find(function (charge) { return charge.name === feeName(item); });
      if (!match && candidates.length === 1 && !feeName(item)) match = candidates[0];
      if (!match) { updates[item.key] = 0; return; }
      var identity = match.variantId + '|' + match.name;
      if (record.found[identity]) { updates[item.key] = 0; return; }
      record.found[identity] = item;
      var quantity = Number(record.parent.quantity) * match.quantityPerDoor;
      if (!safeInteger(quantity, 1)) throw new Error('The door quantity could not be verified.');
      if (Number(item.quantity) !== quantity) updates[item.key] = quantity;
    });
    var additions = [];
    records.forEach(function (record) {
      record.charges.forEach(function (charge) {
        if (record.found[charge.variantId + '|' + charge.name]) return;
        additions.push({id:charge.variantId, quantity:Number(record.parent.quantity) * charge.quantityPerDoor, parent_line_key:record.parent.key, properties:{_hn_aluminum_fee:'true', _hn_aluminum_config:token(record.parent), _hn_aluminum_fee_name:charge.name, Option:charge.name}});
      });
    });
    return {parents:records, updates:updates, additions:additions};
  }
  function verify(cart) {
    var plan = analyze(cart);
    if (Object.keys(plan.updates).length || plan.additions.length) throw new Error('The selected door options could not be verified. Please try again.');
    var expected = 0;
    var actual = 0;
    plan.parents.forEach(function (record) {
      record.charges.forEach(function (charge) {
        var item = record.found[charge.variantId + '|' + charge.name];
        var unit = Number(item.original_price == null ? item.price : item.original_price);
        var line = Number(item.original_line_price == null ? unit * Number(item.quantity) : item.original_line_price);
        var required = charge.priceCents * Number(record.parent.quantity) * charge.quantityPerDoor;
        if (unit !== charge.priceCents || line !== required) throw new Error('A selected door option price has changed. Please return to the door page and reselect the options.');
        expected += required;
        actual += line;
      });
    });
    if (actual !== expected) throw new Error('The door option charges could not be verified.');
    return {cart:cart, optionTotalCents:actual, parentCount:plan.parents.length};
  }
  function refreshCart() {
    if (window.T4SThemeSP && window.T4SThemeSP.Cart && typeof window.T4SThemeSP.Cart.getToFetch === 'function') {
      window.T4SThemeSP.isATCSuccess = false;
      window.T4SThemeSP.Cart.getToFetch(false);
    }
    document.dispatchEvent(new CustomEvent('hn:aluminum-cart-synced', {detail:{count:lastCart && lastCart.item_count}, bubbles:true}));
  }
  async function reconcile(refresh) {
    var cart = await readCart();
    var changed = false;
    for (var attempt = 0; attempt < 4; attempt++) {
      var plan = analyze(cart);
      if (Object.keys(plan.updates).length) {
        await request('cart/update.js', {updates:plan.updates});
        changed = true;
        cart = await readCart();
        continue;
      }
      if (plan.additions.length) {
        await request('cart/add.js', {items:plan.additions});
        changed = true;
        cart = await readCart();
        continue;
      }
      var result = verify(cart);
      if (changed && refresh) refreshCart();
      clearError();
      return result;
    }
    if (changed && refresh) refreshCart();
    throw new Error('The selected door options could not be updated. Please try again before checkout.');
  }
  function enqueue(refresh) {
    var task = queue.catch(function () {}).then(function () { return reconcile(refresh); });
    queue = task;
    return task;
  }
  function errorElement() { return document.getElementById('hn-aluminum-cart-error'); }
  function clearError() { var element = errorElement(); if (element) element.remove(); }
  function showError(message, anchor) {
    clearError();
    var element = document.createElement('p');
    element.id = 'hn-aluminum-cart-error';
    element.setAttribute('role', 'alert');
    element.textContent = message;
    element.style.cssText = 'padding:12px;margin:12px 0;border:1px solid #b33;color:#9b2020;background:#fff;font-size:14px;line-height:1.5';
    var scope = anchor && anchor.closest('form, [data-cart-wrapper], .t4s-main-cart, #t4s-mini_cart');
    if (scope) scope.appendChild(element); else (document.querySelector('main') || document.body).prepend(element);
    if (typeof element.scrollIntoView === 'function') element.scrollIntoView({block:'nearest', behavior:'smooth'});
  }
  function scheduleSync() {
    snapshotDirty = true;
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () { enqueue(true).catch(function (error) { showError(error.message); }); }, 180);
  }
  function rowFor(element) { return element.closest('[data-cart-key], [data-cart-item], [data-hulkapps-lineitem], .t4s-mini_cart__item, .t4s-page_cart__item'); }
  function keyFor(element) {
    var row = rowFor(element);
    var direct = element.closest('[data-cart-remove][data-id], [data-action-change][data-id]');
    if (direct) return direct.getAttribute('data-id');
    if (!row) return '';
    var control = row.querySelector('[data-action-change][data-id], [data-cart-remove][data-id], .edit_cart_option[data-key], .t4s-cart_price[data-key]');
    return row.getAttribute('data-cart-key') || control && (control.getAttribute('data-id') || control.getAttribute('data-key')) || '';
  }
  function feeFor(element) { var key = keyFor(element); return lastCart && lastCart.items.find(function (item) { return item.key === key && isFee(item); }); }
  function decorateFeeRows() {
    if (!lastCart) return;
    lastCart.items.filter(isParent).forEach(function(item){
      var handle=properties(item)._hn_original_product_handle;var original=properties(item)._hn_original_variant_id;
      if(!/^[a-z0-9-]+$/.test(handle||'')||!safeInteger(original,1))return;
      document.querySelectorAll('[data-cart-key], [data-cart-item], [data-hulkapps-lineitem], .t4s-mini_cart__item, .t4s-page_cart__item').forEach(function(row){
        var probe=row.querySelector('[data-action-change][data-id],[data-cart-remove][data-id],.t4s-cart_price[data-key]');
        var key=row.getAttribute('data-cart-key')||probe&&(probe.getAttribute('data-id')||probe.getAttribute('data-key'));if(key!==item.key)return;
        row.querySelectorAll('a[href*="/products/"]').forEach(function(link){var url=new URL('/products/'+handle,location.origin);url.searchParams.set('variant',String(original));var preview=new URLSearchParams(location.search).get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);link.href=url.pathname+url.search;});
        row.querySelectorAll('.edit_cart_option,[data-action-quickshop]').forEach(function(control){control.hidden=true;control.setAttribute('aria-hidden','true');});
      });
    });
    document.querySelectorAll(cartActionSelector).forEach(function (control) {
      if (!feeFor(control)) return;
      control.setAttribute('aria-disabled', 'true');
      control.setAttribute('data-hn-aluminum-fee-control', '');
      if (control.tagName === 'INPUT') control.readOnly = true;
      else if (control.tagName === 'BUTTON') control.disabled = true;
      else control.setAttribute('tabindex', '-1');
    });
  }
  function protectFeeAction(event) {
    var action = event.target.closest && event.target.closest(cartActionSelector);
    if (!action || !feeFor(action)) return false;
    event.preventDefault();
    event.stopImmediatePropagation();
    var item = feeFor(action);
    if (action.tagName === 'INPUT') action.value = item.quantity;
    showError('This option is included with your door. Change the door quantity to update it.', action);
    return true;
  }
  function termsAccepted(anchor) {
    var scope = anchor && anchor.closest('form');
    if (!scope) scope = anchor && anchor.closest('#t4s-mini_cart, .t4s-main-cart, [data-cart-wrapper]');
    if (!scope) return true;
    var unchecked = Array.from(scope.querySelectorAll('input[type="checkbox"][data-agree-checkbox], input[type="checkbox"][name="terms"], input[type="checkbox"][name="terms_conditions"]')).find(function (input) { return !input.disabled && !input.checked; });
    if (!unchecked) return true;
    showError('Please agree to the terms and conditions before checkout.', anchor);
    unchecked.focus();
    return false;
  }
  function hasLegacyCharges(cart) {
    return cart.items.some(function (item) {
      if (isParent(item) || isFee(item)) return false;
      var values = properties(item);
      if (Number(values._wi_calculated_price) > 0) return true;
      return Object.keys(values).some(function (key) { return key.charAt(0) !== '_' && /\[\s*\$\s*[\d,]+(?:\.\d{1,2})?\s*\]/.test(String(values[key])); });
    });
  }
  function hasManagedCart(cart) { return !!cart && cart.items.some(function (item) { return isParent(item) || isFee(item); }); }
  function replayClick(target) {
    if (!target.isConnected) return;
    bypassTarget = target;
    target.click();
    bypassTarget = null;
  }
  async function checkout(anchor) {
    if (checkoutBusy || !termsAccepted(anchor)) return false;
    checkoutBusy = true;
    if (anchor) anchor.setAttribute('aria-busy', 'true');
    try {
      var result = await enqueue(false);
      if (!termsAccepted(anchor)) return false;
      if (hasLegacyCharges(result.cart)) {
        if (typeof window.hulkappsCheckout !== 'function') throw new Error('Checkout for the selected custom options is unavailable. Please try again.');
        window.hulkappsCheckout();
      } else window.location.assign(rootUrl() + 'checkout');
      return true;
    } catch (error) { showError(error.message, anchor); return false; }
    finally { checkoutBusy = false; if (anchor) anchor.removeAttribute('aria-busy'); }
  }
  function bindJQuery() {
    var library = window.jQuery_T4NT || window.hulkapps_jQuery;
    if (!library || !document.body) return;
    library(document.body).off('cart:updated.hnAluminumCart cart:change.hnAluminumCart').on('cart:updated.hnAluminumCart cart:change.hnAluminumCart', scheduleSync);
  }
  document.addEventListener('click', function (event) {
    var target = event.target.closest && event.target.closest(checkoutSelector);
    if (target) {
      if (bypassTarget === target) { bypassTarget = null; return; }
      if (!hasManagedCart(lastCart) && !snapshotDirty) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (hasManagedCart(lastCart)) checkout(target);
      else readCart().then(function (cart) { if (hasManagedCart(cart)) checkout(target); else replayClick(target); }).catch(function (error) { showError(error.message, target); });
      return;
    }
    var addButton = event.target.closest && event.target.closest('[data-atc-form],button[name="add"],.t4s-sticky-atc__atc');
    if (addButton && (addButton.closest('form') && addButton.closest('form').querySelector('[data-hn-aluminum]') || addButton.matches('.t4s-sticky-atc__atc') && document.querySelector('[data-hn-aluminum]'))) snapshotDirty = true;
    if (protectFeeAction(event)) return;
    var action = event.target.closest && event.target.closest(cartActionSelector);
    if (action && rowFor(action)) setTimeout(scheduleSync, 700);
  }, true);
  document.addEventListener('change', function (event) {
    if (protectFeeAction(event)) return;
    var target = event.target;
    if (target.matches && target.matches('[data-action-change], [data-quantity-value]') && rowFor(target)) setTimeout(scheduleSync, 700);
  }, true);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    var submitter = event.submitter;
    if (bypassForm === form) { bypassForm = null; return; }
    if (!hasManagedCart(lastCart) && !snapshotDirty) return;
    function guardSubmit(anchor) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (hasManagedCart(lastCart)) checkout(anchor);
      else readCart().then(function (cart) {
        if (hasManagedCart(cart)) checkout(anchor);
        else if (form.isConnected) { bypassForm = form; form.requestSubmit(submitter || undefined); bypassForm = null; }
      }).catch(function (error) { showError(error.message, anchor); });
    }
    if (submitter && submitter.matches && submitter.matches(checkoutSelector)) {
      guardSubmit(submitter);
    } else if (form.matches && form.matches('form[action$="/cart"],form[action$="/cart/"]') && form.querySelector('input[type="hidden"][name="checkout"]')) {
      guardSubmit(form.querySelector('[name="checkout"]'));
    }
  }, true);
  ['cart:updated','cart:change','cart:refresh','cart:refresh:opend','cart.requestComplete','hn:aluminum-cart-added'].forEach(function (name) {
    document.addEventListener(name, function () { bindJQuery(); scheduleSync(); });
  });
  window.HNAluminumCart = {sync:function () { snapshotDirty = true; return enqueue(true); }, validate:function () { return readCart().then(verify); }, checkout:checkout, markPending:function () { snapshotDirty = true; }, getSnapshot:function () { return lastCart; }};
  function init() {
    bindJQuery();
    readCart().then(function (cart) {
      if (hasManagedCart(cart)) enqueue(true).catch(function (error) { showError(error.message); });
    }).catch(function () {});
    if (document.body) new MutationObserver(function () { clearTimeout(decorateTimer); decorateTimer = setTimeout(decorateFeeRows, 80); }).observe(document.body, {childList:true, subtree:true});
    setTimeout(bindJQuery, 1500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

